module.exports = __webpack_public_path__ + "static/iPhoneX-6f2f9f37f375293ac6c7e91a2eb81e75.png";